import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery} from '../../../criteria/item-hdr-criteria.model';
import {PagingResponseModel} from '../../shared/api-response.model';
import {Core2Config} from '../../shared/core2Config';
import {DgMktSegmentContainerModel} from '../../../../../../models/aggregates/dgmkt/dgmkt-segment';
import {ApiVisa} from '../../shared/api-visa.model';


@Injectable({
    providedIn: 'root'
})
export class DgMktSegmentService extends BaseApiTemplateService<DgMktSegmentContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DGMKT_MODULE_PREFIX + 'segments';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DGMKT_MODULE_PREFIX + 'segments';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.DGMKT_MODULE_PREFIX + 'segments';
        this.httpClient = http;
    }
}